<template>
  <el-dialog
    v-dialogDrag
    class="large-dialog"
    @close="closeDialog"
    :title="
      formProps.pageType === 'create' ? '新增' : formProps.pageType === 'update' ? '编辑' : '查看'
    "
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <div>
      <el-form ref="form" label-width="180px" :rules="rules" :model="formData">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="设备设施名称" prop="name">
              <el-input
                v-model="formData.name"
                placeholder="请输入设备设施名称"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备设施编号" prop="no">
              <el-input
                v-model="formData.no"
                placeholder="请输入设备设施编号"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类别" prop="type">
              <el-select
                v-model="formData.type"
                class="w-full"
                placeholder="请选择设备类别"
                filterable
                clearable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in equipTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="危险介质" prop="hazardousMedia">
              <el-input
                v-model="formData.hazardousMedia"
                placeholder="请输入危险介质"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备设施所在区域" prop="areaId">
              <el-select
                v-model="formData.areaId"
                class="w-full"
                placeholder="请选择设备设施所在区域"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属单位" prop="ownedUnitId">
              <department-select
                class="mr-10px w-full"
                v-model="formData.ownedUnitId"
                :disabled="formProps.pageType === 'read'"
              ></department-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否属于特种设备" prop="isSpecial">
              <el-select
                v-model="formData.isSpecial"
                class="w-full"
                placeholder="请选择是否属于特种设备"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in deviceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="kks编码" prop="kksNo">
              <el-input
                v-model="formData.kksNo"
                placeholder="请输入kks编码"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属风险分析单元" prop="riskAnalysisUnitId">
              <el-select
                v-model="formData.riskAnalysisUnitId"
                class="w-full"
                placeholder="请选择所属风险分析单元"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.unitName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片" prop="imageIds">
              <img-upload
                v-model="formData.imageIds"
                :upload-width="120"
                :upload-height="120"
                :maxSize="20"
                :limit="5"
                :isDisabledUploadComponent="formProps.pageType === 'read'"
                :isShowDeleteButton="formProps.pageType !== 'read'"
              ></img-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="设备备注" prop="remark">
              <el-input
                type="textarea"
                :rows="4"
                maxlength="5000"
                show-word-limit
                v-model="formData.remark"
                placeholder="请输入设备备注"
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-if="formProps.pageType !== 'read'">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm" :loading="loading"
          >保存</el-button
        >
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import {
  EquipmentFacilityListApi,
  RiskAnalysisUnitApi,
} from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const areaApi = new AreaApi()
const equipmentFacilityListApi = new EquipmentFacilityListApi()
const riskAnalysisUnitApi = new RiskAnalysisUnitApi()
export default {
  name: 'equip-form',
  components: {
    ImgUpload,
    DepartmentSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    return {
      visible: true,
      loading: false,
      formData: null,
      rules: {
        name: [{ required: true, message: '请输入设备设施名称', trigger: ['blur', 'change'] }],
        no: [{ required: true, message: '请输入设备设施编号', trigger: ['blur', 'change'] }],
        areaId: [
          { required: true, message: '请选择设备设施所在区域', trigger: ['blur', 'change'] },
        ],
        ownedUnitId: [{ required: true, message: '请选择所属单位', trigger: ['blur', 'change'] }],
      },
      userList: [],
      equipTypeList: [],
      areaList: [],
      deviceList: [
        {
          label: '是',
          value: true,
        },
        {
          label: '否',
          value: false,
        },
      ],
      unitList: [],
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      immediate: true,
    },
  },
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.EquipmentType'],
      ['equipTypeList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
    // 获取分析单元数据
    this.getUnitList()
  },
  methods: {
    // 获取分析单元数据
    async getUnitList() {
      const [err, res] = await riskAnalysisUnitApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.unitList = res.items
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 表单提交
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = false
          this.formData = utils.deleteFormField(this.formData)
          if (this.formProps.pageType === 'create') {
            const [err, res] = await equipmentFacilityListApi.create({ body: this.formData })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
          } else {
            const [err, res] = await equipmentFacilityListApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
          }
          this.loading = false
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss"></style>
